/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentDto } from '../models/document-dto';
import { preDocumentControllerAiTest } from '../fn/pre-document/pre-document-controller-ai-test';
import { PreDocumentControllerAiTest$Params } from '../fn/pre-document/pre-document-controller-ai-test';
import { preDocumentControllerFindByCenterChild } from '../fn/pre-document/pre-document-controller-find-by-center-child';
import { PreDocumentControllerFindByCenterChild$Params } from '../fn/pre-document/pre-document-controller-find-by-center-child';
import { preDocumentControllerUpdate } from '../fn/pre-document/pre-document-controller-update';
import { PreDocumentControllerUpdate$Params } from '../fn/pre-document/pre-document-controller-update';
import { TestDto } from '../models/test-dto';

@Injectable({ providedIn: 'root' })
export class PreDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `preDocumentControllerFindByCenterChild()` */
  static readonly PreDocumentControllerFindByCenterChildPath = '/api/pre-document';

  /**
   * 진행 전 문서 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preDocumentControllerFindByCenterChild()` instead.
   *
   * This method doesn't expect any request body.
   */
  preDocumentControllerFindByCenterChild$Response(params: PreDocumentControllerFindByCenterChild$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
    return preDocumentControllerFindByCenterChild(this.http, this.rootUrl, params, context);
  }

  /**
   * 진행 전 문서 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preDocumentControllerFindByCenterChild$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preDocumentControllerFindByCenterChild(params: PreDocumentControllerFindByCenterChild$Params, context?: HttpContext): Observable<Array<DocumentDto>> {
    return this.preDocumentControllerFindByCenterChild$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentDto>>): Array<DocumentDto> => r.body)
    );
  }

  /** Path part for operation `preDocumentControllerUpdate()` */
  static readonly PreDocumentControllerUpdatePath = '/api/pre-document';

  /**
   * 문서 업데이트
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preDocumentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preDocumentControllerUpdate$Response(params: PreDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return preDocumentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 업데이트
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preDocumentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  preDocumentControllerUpdate(params: PreDocumentControllerUpdate$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.preDocumentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `preDocumentControllerAiTest()` */
  static readonly PreDocumentControllerAiTestPath = '/api/pre-document/ai-test';

  /**
   * AI 테스트
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `preDocumentControllerAiTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  preDocumentControllerAiTest$Response(params?: PreDocumentControllerAiTest$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
    return preDocumentControllerAiTest(this.http, this.rootUrl, params, context);
  }

  /**
   * AI 테스트
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `preDocumentControllerAiTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  preDocumentControllerAiTest(params?: PreDocumentControllerAiTest$Params, context?: HttpContext): Observable<TestDto> {
    return this.preDocumentControllerAiTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestDto>): TestDto => r.body)
    );
  }

}
